import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Checkbox.css";
/**
 * @desc Checkbox
 * @param props
 * @return null
 */
const Checkbox = props => {
  const { className, ...other } = props;
  return (
    <React.Fragment>
      <label className="ui-checkbox__label">{props.label}</label>
      <div className={"ui-checkbox " + className}>
        <input className="ui-checkbox__input" type="checkbox" {...other} checked={props.checked}/>
        <div className="check" />
      </div>
    </React.Fragment>
  );
};

Checkbox.propTypes = {
  /** ClassName will be injected into the component's container (not the button element itself). You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** The label of the checkbox */
  label: PropTypes.string
};

Checkbox.defaultProps = {
  className: "",
  label: ""
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/UI/Checkbox/Checkbox.js